/**
 * 어플발주 최종확인 모달 (BS 사용)
 *
 * 호출:
 *   $j.Ui.BS.open({
 *       target: $j.F.Baljoo.ModalConfirm,
 *       data:   { order, onApply }
 *   });
 *
 *   data.order   : ORDER 객체
 *   data.onApply : 사용자가 "적용" 클릭 시 호출되는 콜백
 *
 * BS 가 자동으로 this.id (컨테이너 div id), this.parent (BS 인스턴스),
 * this.data 를 주입한 뒤 init() 을 호출한다.
 */
import Util from '../../../Common/Util';

export default class ConfirmModal {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
    }

    init() {
        const order = this.data?.order || {};

        this.parent.setTitle('최종확인');

        // skeleton 동기 렌더링 후 데이터 fill
        $('#' + this.id).html(this.skeletonHtml());
        this.fillFields(order);
        this.bindHandlers(order);
    }

    skeletonHtml() {
        return `
<div style="display:flex;flex-direction:column;gap:4px;">
    <div style="display:flex;justify-content:space-between;align-items:center;height:30px;">
        <h2 style="font-weight:bold;">최종확인</h2>
    </div>

    <div style="display:flex;justify-content:space-between;align-items:center;height:30px;">
        <div style="font-size:12px;">소속본사</div>
        <div style="font-weight:bold;font-size:12px;" id="window-confirm-bonsa"></div>
    </div>

    <div style="padding: 12px;padding-top: 16px;padding-bottom: 16px;background:#f1f1f1;border-radius:16px;box-shadow:0px 4px 4px rgba(0,0,0,0.01);height:251px;">
        <ul style="display:flex;flex-direction:column;gap:2px;overflow-hidden;">
            <li style="display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <figure style="width:24px;"><img src="/img/testmon.svg" alt=""></figure>
                    <span style="font-size:10px;">옵션</span>
                </div>
                <div style="display:flex;justify-content:flex-end;align-items:center;gap:4px;word-wrap: break-word;width:80%;">
                    <div style="font-weight:bold;" id="window-confirm-car_type"></div>
                    <div style="font-weight:bold;" id="window-confirm-option"></div>
                </div>
            </li>
            <li style="display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <figure style="width:24px;"><img src="/img/calmon.svg" alt=""></figure>
                    <span style="font-size:10px;">날짜</span>
                </div>
                <div id="window-confirm-work_day" style="font-weight:bold;text-align:right;word-wrap: break-word;width:80%;"></div>
            </li>
            <li style="display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <figure style="width:24px;"><img src="/img/locmon.svg" alt=""></figure>
                    <span style="font-size:10px;">도착</span>
                </div>
                <div id="window-confirm-work_hm" style="font-weight:bold;text-align:right;word-wrap: break-word;width:80%;"></div>
            </li>
            <li style="display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <figure style="width:24px;"><img src="/img/workmon.svg" alt="공수"></figure>
                    <span style="font-size:10px;">공수</span>
                </div>
                <div id="window-confirm-howlong" style="font-weight:bold;text-align:right;word-wrap: break-word;width:80%;"></div>
            </li>
            <li style="display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <figure style="width:24px;"><img src="/img/apamon.svg" alt="adress"></figure>
                    <span style="font-size:10px;">주소</span>
                </div>
                <div style="font-weight:bold;text-align:right;word-wrap: break-word;width:80%;" id="window-confirm-addr"></div>
            </li>
        </ul>
    </div>

    <div>
        <ul style="display:flex;flex-direction:column;gap:4px;margin-top:10px;height:120px;gap:12px;">
            <li style="display:flex;justify-content:space-between;align-items:center;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <span style="font-size:12px;white-space:nowrap;">현장번호</span>
                </div>
                <div style="wfont-weight:bold;text-align:right;word-wrap: break-word;width:80%;" id="window-confirm-contract_fieldnumber"></div>
            </li>
            <li style="display:flex;justify-content:space-between;align-items:center;align-items:flex-start;">
                <div style="display:flex;justify-content:center;align-items:center;flex-direction:column;margin-right:16px;min-width:24px;">
                    <span style="font-size:12px;white-space:nowrap;">전달사항</span>
                </div>
                <div style="font-weight:bold;text-align:right;word-wrap: break-word;width:80%;" id="window-confirm-contract_message"></div>
            </li>
        </ul>
    </div>
    <div style="height:1px;background-color:#ddd;"></div>
    <div style="height:60px;">
        <ul style="text-align:right;">
            <li style="font-size:24px;color:red;font-weight:bold;" id="window-confirm-car_price"></li>
            <li id="window-confirm-fee"></li>
        </ul>
    </div>

    <div>
        <div id="window-confirm-notfilled-message" style="text-align:center;padding-top:6px;padding-bottom:6px;">
            <p style="font-size:12px;"><span style="color:red;font-size:12px;font-weight:bold;" id="window-confirm-notfilled-items">소요시간, 기종/옵션</span>을 선택하시지 않으셔서</p>
            <p style="font-size:12px;">발주 미완 상태로 접수됩니다.</p>
            <p style="font-size:12px;">상담원에게 정확한 발주 정보를 말씀해주세요.</p>
        </div>
    </div>

    <div style="height:50px;display:flex;justify-content:center;align-items:center;gap:12px;">
        <a id="window-confirm-modify" href="#" style="display:flex;justify-content:center;align-items:center;width:40%;background:#ddd;border-radius:8px;height:45px;">
            수정하기
        </a>
        <a id="window-confirm-apply" href="#" style="display:flex;justify-content:center;align-items:center;width:60%;background:#FFD43B;border-radius:8px;height:45px;font-weight:bold;">
            발주하기
        </a>
    </div>
</div>`;
    }

    /** BS 가 닫힐 때 호출 */
    destroy() {
        $('#' + this.id).off();
    }

    fillFields(data) {
        if (data.$t && data.$t['is_mini']) {
            const arr = [];
            if (!data['car_range'])         arr.push('기종/옵션');
            if (data['car_workhour'] == 0) arr.push('소요시간');
            $('#window-confirm-notfilled-items').html(arr.join(','));
        } else {
            $('#window-confirm-notfilled-message').hide();
        }

        const ymd = dayjs(data['work_time']).format('YYYY년 MM월 DD일');
        let hm = Util.getYoil(data['work_day']);
        hm += dayjs(data['work_time']).format('HH시 mm분');
        if (data['is_quick'] == 1) hm += ' 긴급';

        let feeStr = '(VAT별도,수수료 ';
        feeStr += data['is_fee'] == 1 ? '있음)' : '없음)';

        let howtopayStr = G5['HOW_TO_PAY'][data['howtopay']];
        if (data['howtopay'] == 1) {
            howtopayStr += '(결제예정: ' + G5['SIGN_DUE'][data['sign_howlong_int']] + ')';
        }

        let p = data['car_price'];
        if (data['car_price_bonsa']) p = data['car_price_bonsa'];

        $('#window-confirm-bonsa').html(bonsaList[data['order_sosok'].substring(0, 3)]);
        $('#window-confirm-car_type').html(data['car_type']);
        $('#window-confirm-work_day').html(ymd);
        $('#window-confirm-work_hm').html(hm);
        $('#window-confirm-addr').text(Util.nvl(data['contract_address']));
        $('#window-confirm-howlong').html($j.F.Car.getWorkHourStr(data));
        $('#window-confirm-fee').html(feeStr);
        $('#window-confirm-worktype').text(Util.nvl(data['car_worktype']));
        $('#window-confirm-howtopay').html(howtopayStr);
        $('#window-confirm-contract_fieldnumber').text(Util.nvl(data['contract_fieldnumber']));
        $('#window-confirm-contract_name').text(Util.nvl(data['contract_name']));
        $('#window-confirm-option').text($j.F.Car.getCarRangeStr(data) + ' ' + $j.F.Car.getCarOptionStr(data));
        $('#window-confirm-car_price').html(Util.formatNumber(p) + 'P');
        $('#window-confirm-contract_message').html(Util.escapeHtml(data['contract_message']).replace(/&lt;\/?br\s*\/?&gt;/gi, '<br>'));
    }

    bindHandlers(/* order */) {
        const self = this;

        $('#window-confirm-modify').on('click', function (e) {
            e.preventDefault();
            self.parent.close();
        });

        $('#window-confirm-apply').on('click', function (e) {
            e.preventDefault();
            const cb = self.data?.onApply;
            self.parent.close();
            if (typeof cb === 'function') cb();
        });
    }
}
